export default __webpack_public_path__ + "static/media/timeCircle.fb8f419e.svg";